import React from 'react';

/**
 * LoadingButton - A button component that shows a centered spinner when loading
 * 
 * Uses the global btn-loading styles from index.css for consistent behavior.
 * The button maintains its size when loading - content is hidden but preserved
 * for sizing, and the spinner is absolutely positioned in the center.
 * 
 * @param {boolean} loading - Whether the button is in loading state
 * @param {string} className - Button variant class (e.g., 'btn-primary', 'btn-secondary')
 * @param {React.ReactNode} children - Button content (icon + text)
 * @param {boolean} disabled - Whether the button is disabled
 * @param {string} type - Button type ('button', 'submit', 'reset')
 * @param {function} onClick - Click handler
 * @param {object} style - Additional inline styles
 * @param {string} title - Button title/tooltip
 */
function LoadingButton({
  loading = false,
  className = 'btn-primary',
  children,
  disabled = false,
  type = 'button',
  onClick,
  style,
  title,
  ...props
}) {
  return (
    <button
      type={type}
      className={`${className} ${loading ? 'btn-loading' : ''}`}
      disabled={disabled || loading}
      onClick={onClick}
      style={style}
      title={title}
      {...props}
    >
      <span className="btn-content">{children}</span>
      {loading && <span className="btn-spinner" />}
    </button>
  );
}

export default LoadingButton;
